import React, { useEffect, useMemo, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import { getPayments, getUsers, getPlans } from '../data/mockData';
import FloatingActionButton from '../components/shared/FloatingActionButton';
import PaymentsTable from '../components/payments/PaymentsTable';
import AddPaymentModal from '../components/payments/AddPaymentModal';
import ReceiptModal from '../components/payments/ReceiptModal';
import api from '../services/ApiService';
import { ENDPOINTS } from '../constant/ApiEndpoints';
import useDidFetch from '../custom_hooks/useDidfetch';
import PaymentToolbar from '../components/payments/PaymentToolbar';

const PaymentManagementPage = () => {
    const [payments, setPayments] = useState([]);
    const [filters, setFilters] = useState({ search: '', plan: 'All', paymentMethod: 'All' });
    const [users, setUsers] = useState([]);
    const [plans, setPlans] = useState([]);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isReceiptModalOpen, setIsReceiptModalOpen] = useState(false);
    const [activePayment, setActivePayment] = useState(null);
    const [paymentLoading, setPaymentLoading] = useState(false);

    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getAllPayments();
            getAllPlans();
            getAllUser()
        });
    }, []);

    const filteredPayments = useMemo(() => {
        return payments.filter(payment => {
            if (!filters.search && !filters.plan) {
                return payments;
            } 
            const searchLower = filters.search.toLowerCase();
            const nameMatch = payment?.user.name.toLowerCase().includes(searchLower); 
            const memberIdMatch = payment?.user.member_id.toLowerCase().includes(searchLower);
            const paymentMethod = filters.paymentMethod === 'All' || payment?.payment_method == filters.paymentMethod; 
            const planMatch = filters.plan === 'All' || payment?.plan.id == filters.plan;
            return (nameMatch || memberIdMatch) && planMatch && paymentMethod;
        });
    }, [payments, filters]);

    const getAllPlans = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getPlan);
            const result = response?.data;
            console.log(response);
            if (response.status === 200 || response.status === 201) {
                setPlans(result ?? []);
            }
        } catch (error) {
            console.error("plans get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const getAllUser = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getUser);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setUsers(result?.users ?? []);
            } else {
                toast.error(result?.message || "Login failed!");
            }
        } catch (error) {
            console.error("user get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }

    const getAllPayments = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getPayment);
            const result = response?.data;
            console.log(result)
            setPayments(result ?? []);

        } catch (error) {
            console.error("payment get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }

    const handleAddPayment = () => setIsAddModalOpen(true);

    const handleSavePayment = async (paymentData) => {
        console.log(paymentData);
        let obj = {
            "user_id": paymentData?.memberId,
            "plan_id": paymentData?.planName?.id,
            "amount": paymentData?.amount,
            "payment_method": paymentData?.method,
            // "transaction_id": "TXN987654",
            "status": "paid"
        }
        try {
            setPaymentLoading(true);
            const response = await api.post(ENDPOINTS.savePayment, obj);
            const result = response?.data;
            console.log(result);

            if (response?.status == 200 || response?.status == 201) {
                setIsAddModalOpen(false);
                toast.success('Payment recorded successfully.'); 
                getAllPayments();
            }

        } catch (error) {
            console.error("payment get error:", error);
            toast.error(error.response?.data?.message || "Something went wrong!");
        } finally {
            setPaymentLoading(false);
        }
    };

    const handleViewReceipt = (payment) => {
        setActivePayment(payment);
        setIsReceiptModalOpen(true);
    };
    
    

    return (
        <>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="space-y-6"
            >
                <h1 className="text-3xl font-bold font-display text-gray-800">Payment Management</h1>
                <PaymentToolbar filters={filters} onFilterChange={setFilters} plans={plans} />


                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
                    <PaymentsTable payments={filteredPayments} onViewReceipt={handleViewReceipt} />
                </div>

                <FloatingActionButton onClick={handleAddPayment}>
                    <Plus size={24} />
                </FloatingActionButton>
            </motion.div>

            <AddPaymentModal
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                onSave={handleSavePayment}
                members={users.filter(u => u.role?.name === 'member')}
                plans={plans}
                isLoading={paymentLoading}
            />

            <ReceiptModal
                isOpen={isReceiptModalOpen}
                onClose={() => setIsReceiptModalOpen(false)}
                payment={activePayment}
            />
        </>
    );
};

export default PaymentManagementPage;
